import gql from 'graphql-tag';

// languagePackId needs to be added when available on HUBQL
export const currentUser = gql`
	{
		currentUser {
			id
			firstName
			lastName
			accessLevel
			dataname
			username
			lavuAdmin
			email
			accessWhiteList
			primaryCurrencyCode
			restrictedUser
			dateFormat
			languagePack {
				englishName
				googleCode
			}
			trialInfo {
				status
				daysRemaining
			}
			newReports
			startDayOfWeek
			navItems {
				id
				name
				path
				phpPath
				hide
				subItems {
					name
					path
					phpPath
					isModal
					hide
				}
			}
		}
	}
`;

/**
 * Query to get an array of settings values.
 */
export const settings = gql`
	query settings($settings: [Utf8String]) {
		settings(settings: $settings) {
			value
		}
	}
`;

export default {
	currentUser,
	settings,
};
